import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {PreviewInvoicesAction, previewInvoicesActionTypes} from '../actions/preview-invoices';
import {companyActionTypes} from '../actions/company-load';

export interface InvoicesPreviewState {
  // tslint:disable-next-line:no-any
  invoicesPreview: any;
}

const initialState: InvoicesPreviewState = {
  invoicesPreview: undefined
};

export function InvoicesPreviewReducer(state: InvoicesPreviewState = initialState, action: Action): InvoicesPreviewState {
  switch (action.type) {
    case previewInvoicesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case previewInvoicesActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case previewInvoicesActionTypes.CLEAR:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}


function handleLoadSuccessAction(state: InvoicesPreviewState, action: PreviewInvoicesAction): InvoicesPreviewState {
  return  {  invoicesPreview: action.payload.array  };
}


function handleLoadErrorActions(state: InvoicesPreviewState): InvoicesPreviewState {
  return state;
}


export const invoicesPreviewSelectors = {
  invoicesPreview: (state: InvoicesPreviewState) => _.get(state, 'invoicesPreview', null)
};
